import React from 'react';
import ClassAssembly  from 'views/Class7D';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;